import { get } from 'lodash-es';
/**
 * FIXME - this is leftover and should be moved to channelModel as we now have decoupled channels from navigation
 * @param raw
 * @return {{parentId: number, id: number, title: string, slug: string, active: boolean, url: string}}
 */
// TODO @techdept
export const navigationItemModel = (raw) =>
  raw && {
    parentId: raw.parentId,
    id: raw.id,
    title: raw.name,
    slug: raw.slug || 'slug',
    active: false,
    //homepage has specifically null as parentId - really bad decision
    //FIXME - simplify logic around homepage
    url: channel2url(raw),
  };

export const channel2url = (channel) => {
  return !get(channel, 'parentId') ? '/' : `/channel/${channel.id}/${channel.slug}/1`;
};
